module.exports = __webpack_public_path__ + "img/shopping.40d74f07.svg";